import { useEffect, useState } from 'react';

import { db } from 'src/utils/firebase'; // Adjust the import path based on your file structure

function useBudgetSnapshots(userId) {
  const [budgetSnapshots, setBudgetSnapshots] = useState([]);

  useEffect(() => {
    // Check if the user is authenticated before querying for transactions
    if (!userId) {
      setBudgetSnapshots([]); // Set transactions to an empty array when the user is not authenticated
      return () => {}; // Exit the useEffect early
    }

    const unsubscribe = db
      .collection('budget_snapshots')
      .where('user_id', '==', userId)
      .onSnapshot((snapshot) => {
        console.log('budget snapshots updated...');
        const fetchedBudgetSnapshots = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setBudgetSnapshots(fetchedBudgetSnapshots);
      });

    return () => unsubscribe();
  }, [userId]);

  return budgetSnapshots;
}

export default useBudgetSnapshots;
